import { CommonModule, DatePipe } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ClozeTestStyleModel } from 'gast-onset-ng2';
import { DeviceDetectorService } from 'ngx-device-detector';
import { OnsetExamDataDto } from '../../shared/dtos/onset-exam-data-dto';
import { ConnectorAuthService } from '../../shared/services/common/connector-auth.service';
import { IdasService } from '../../shared/services/idas/idas.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, DatePipe]
})
export class HomeComponent implements OnInit {

  readonly #deviceService = inject(DeviceDetectorService);
  readonly #idasService = inject(IdasService);
  readonly #authService = inject(ConnectorAuthService);
  readonly #router = inject(Router);
  readonly #route = inject(ActivatedRoute);

  title = signal('');
  subtitle = signal('');
  content = signal('');
  clozeTestStyleModel = signal<ClozeTestStyleModel | null>({} as ClozeTestStyleModel);
  cTestLogo = signal('');
  cTestButtonColor = signal('');
  mobileMode = signal(false);
  totalExercise = signal(0);
  currentExcerciseNumber = signal(0);
  onsetExamDataDto = signal<OnsetExamDataDto | null>(null);
  isLoading = signal(false);

  ngOnInit() {
    // detect mobile
    this.mobileMode.set(this.#deviceService.isMobile());
    console.log('is mobile device: ' + this.mobileMode());

    // generate style
    this.clozeTestStyleModel.set(this.#generateClozeTestStyle());

    // sett logo and button color
    this.cTestLogo.set('onset-assets/img/onset_logo.png');
    this.cTestButtonColor.set(this.clozeTestStyleModel()!.onsetColor);

    this.#idasService.getOnsetExamDataCompleted.subscribe((onsetExamDataDto: OnsetExamDataDto) => {
      this.onsetExamDataDto.set(onsetExamDataDto);
      this.isLoading.set(false);

      this.#authService.login(onsetExamDataDto);
    });

    // callback for query parameter
    this.#route.queryParams.subscribe(params => {
      if (params['token']) {
        const token = params['token'] as string;
        this.#idasService.getOnsetExamData(token);
        this.isLoading.set(true);
      }
    });
  }

  startOnset(): void {
    this.#router.navigate(['idas-onset'], { queryParamsHandling: 'preserve' });
  }

  #generateClozeTestStyle(): ClozeTestStyleModel {
    // TODO config
    const model = {} as ClozeTestStyleModel;
    model.siteBackground = '#ffffff';
    model.exerciseBackground = '#EEF3F8';
    model.frameColor = '#92aac1';
    model.barColor = '#b3c9de';
    model.specialCharacterListColor = '#b3c9de';
    model.specialChcaracterTextColor = '#000000';
    model.exerciseTextColor = '#000000';
    model.buttonsColor = '#fa9463';
    model.testdafColor = '#57a7d6';
    model.onsetColor = '#a5d8db';
    model.duoColor = '#ed6a5b';
    model.testasColor = '#fac075';
    model.font = 'arial, helvetica, sans-serif';
    model.fontSize = '11pt';
    model.displayLogo = true;
    model.cTestInformationUrl = 'http://www.wikipedia.com/';
    return model;
  }
}
